import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {Store} from "@ngrx/store";
import * as fromStore from "../../../../store";
import {ActivatedRoute, Router} from "@angular/router";
import { GoogleAnalyticsService } from '../../../../shared/services/google-analytics/google-analytics.service';
import {IBoosterStats} from "../../../../store/reducers/booster.reducer";
import {first, switchMap, takeUntil} from "rxjs/operators";
import {combineLatest} from "rxjs";
import {UserSubscription} from "../../../../user/user-subscription";
import {Subject} from "rxjs";
import {DbModalService} from "../../../../modules/modal/modal";
import {Utils} from "../../../../shared/utils/utils";

@Component({
    selector: 'db-optimize-with-booster-pro',
    templateUrl: './optimize-with-booster-pro.component.html',
    styleUrls: ['./optimize-with-booster-pro.component.scss'],
    standalone: false
})
export class OptimizeWithBoosterProComponent implements OnChanges, OnInit {

  @Input() imageStats?: IBoosterStats;
  @Input() websiteId: number;
  @Input() pageCount: string = '0';
  public userSubscription: UserSubscription;
  public showPercentOffer: boolean;
  public items: any[] = [
    {
      title: 'Full frontend optimization',
      subFeatures: [(this.pageCount && this.pageCount === '1' ? this.pageCount + ' page' :  this.pageCount && this.pageCount !== '1' ? this.pageCount + ' pages' : 'All pages ') + ' & all ' + (this.imageStats && this.imageStats.notCompressed  ? this.imageStats && this.imageStats.notCompressed : '' ) + 'images']
    },
    {
      title: 'Optimization of unlimited new pages and images',
    },
    {
      title: 'Pro optimization with Cloudflare CDN',
      subFeatures: [
        '2x faster load times',
        '50% higher PageSpeed score',
        '275 caching locations',
        'DDoS protection and WAF',
        'Full page caching',
        'SSL certificate'
      ]
    }

  ];
  private _destroyStream$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private _router: Router,
    private _route: ActivatedRoute,
    private _store: Store<fromStore.DbStoreState>,
    private _modalService: DbModalService,
    private _googleAnalyticsService: GoogleAnalyticsService,
  ) {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['imageStats'] ? this.imageStats = changes['imageStats'].currentValue : changes['pageCount'] ?
      this.pageCount = changes['pageCount'].currentValue : '') {
      this.items[0].subFeatures = [(this.pageCount && this.pageCount === '1' ? this.pageCount + ' page' :  this.pageCount && this.pageCount !== '1' ? this.pageCount + ' pages' : 'All pages ') + ' and all ' +
      (this.imageStats && this.imageStats.notCompressed  ? this.imageStats && this.imageStats.notCompressed : '' ) + ' images'];
    }
  }

  ngOnInit(): void {
    this._getUserSubscription();
    this._showPercentOffer();
  }

  private _showPercentOffer() {
    const percentOfferEndDate = new Date("2024-01-30 18:00:00").getTime();
    const datesDiff = Utils.getTimeDiffFromToday(percentOfferEndDate);
    this.showPercentOffer = datesDiff && this.userSubscription && this.userSubscription.trialBoosterClient;
  }

  private _getUserSubscription(): void {
    this._store.select(fromStore.getUserLoaded)
      .pipe(
        first((loaded: boolean) => loaded),
        switchMap(() => combineLatest(
            this._store.select(fromStore.getUserSubscription)
          )
        ),
        takeUntil(this._destroyStream$)
      )
      .subscribe(([ userSubscription]) => {
        this.userSubscription = userSubscription;
      });
  }

  public redirectToBoosterPro(): void {
    this._router.navigate(['/upgrade-plan']);
  }

}
